module.exports = __webpack_public_path__ + "static/img/nanoscience_thumbnail.acb2940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/nanoscience_thumbnail.jpg
// module id = RIBX
// module chunks = 6